import NativeTouchableOpacity from "react-native-web/dist/exports/TouchableOpacity";
export var TouchableOpacity = NativeTouchableOpacity;